
      if (location.hostname.endsWith('lovable.app') || location.hostname.endsWith('lovableproject.com')) {
        const s = document.createElement('script');
        s.src = 'https://cdn.gpteng.co/gptengineer.js';
        s.type = 'module';
        document.head.appendChild(s);
      }
    